module.exports = __webpack_public_path__ + "static/media/08.5023f4bf.jpg";